import { styled as r, modifier as i, css as e } from "@lokalise/styled";
import { value as t } from "../../utils/theme/index.js";
import { Pressable as l } from "../Pressable/index.js";
import { withLinkStyle as m } from "../../utils/styles/link.js";
const s = r(l)`
	${m};

	${i(
  ({ href: o }) => !o,
  e`
			&:disabled {
				cursor: not-allowed;
				color: ${t("color.text.disabled")};
			}
		`
)}
`;
s.displayName = "Link";
export {
  s as Link
};
//# sourceMappingURL=Link.js.map
